import { Box, Flex, Skeleton } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import { getIndicatorDetail } from 'redux/IndicatorPageSlice';

import MultiDimensionTable from './MultiDimensionTable';
import MultiDimensionTableOpz from './MultiDimensionTableOpz';

interface Properties {
  refetchRequest: () => void;
  isPercentage: any;
  flags?: any;
}

const IndicatorTable = ({ refetchRequest, isPercentage, flags }: Properties) => {
  const indicator: any = useSelector(getIndicatorDetail);

  if (!indicator) {
    return (
      <Flex direction='column' pb='1'>
        {[...new Array(6)].map((_, index) => (
          <Flex key={index} p={2} justifyContent={'space-between'}>
            {[...new Array(4)].map((__, subIndex: number) => (
              <Box key={subIndex} flex={1} mr={2}>
                <Skeleton startColor='white' endColor='#CCD4E8' height='35px' width={'100%'} />
              </Box>
            ))}
          </Flex>
        ))}
      </Flex>
    );
  }

  return (
    <Flex ms={2} mt={2}>
      {flags?.inputPanelOptimization ? (
        <MultiDimensionTableOpz refetchRequest={refetchRequest} isPercentage={isPercentage} />
      ) : (
        <MultiDimensionTable refetchRequest={refetchRequest} isPercentage={isPercentage} />
      )}
    </Flex>
  );
};
export default withLDConsumer()(IndicatorTable);
